import {
  getMyLeaves as getMyLeavesService,
  updateLeaveAction as updateLeaveActionService,
} from "services/company/leaveManagement/leaveDetails/leaveDetailsService";
import {
  getLeavesStart,
  getLeavesSuccess,
  getLeavesFailure,
  updateLeaveActionStart,
  updateLeaveActionSuccess,
  updateLeaveActionFailure,
} from "./leaveDetailsSlice";
import { showSuccessToast, showErrorToast } from "utils/toastNotification";

// Fetch all leaves
export const fetchMyLeaves = () => async (dispatch) => {
  try {
    dispatch(getLeavesStart());
    const response = await getMyLeavesService();

    if (response?.meta?.status === true && response?.meta?.code === 200) {
      dispatch(getLeavesSuccess(response.data));
      return { success: true, data: response.data };
    } else {
      const errorMsg = response?.meta?.message || "Failed to fetch leaves";
      dispatch(getLeavesFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    console.error("Fetch leaves error:", error);
    const errorMsg =
      error?.response?.data?.meta?.message ||
      error.message ||
      "Failed to fetch leaves";
    dispatch(getLeavesFailure(errorMsg));
    showErrorToast(errorMsg);
    return { success: false, error: errorMsg };
  }
};

// Update leave action (approve/reject)
export const updateLeaveAction = (leaveId, actionData) => async (dispatch) => {
  try {
    dispatch(updateLeaveActionStart());
    const response = await updateLeaveActionService(leaveId, actionData);

    if (response?.meta?.status === true && response?.meta?.code === 200) {
      // Fetch updated leaves after action
      await dispatch(fetchMyLeaves());
      dispatch(updateLeaveActionSuccess({ id: leaveId, ...actionData }));
      showSuccessToast(
        response?.meta?.message || `Leave ${actionData.action} successfully!`,
      );
      return { success: true, data: response.data };
    } else {
      const errorMsg =
        response?.meta?.message || "Failed to update leave action";
      dispatch(updateLeaveActionFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    console.error("Update leave action error:", error);
    const errorMsg =
      error?.response?.data?.meta?.message ||
      error.message ||
      "Failed to update leave action";
    dispatch(updateLeaveActionFailure(errorMsg));
    showErrorToast(errorMsg);
    return { success: false, error: errorMsg };
  }
};
